export default __webpack_public_path__ + "static/media/marke_1.707a4fd6.png";